import { render } from "./TopicCardView.vue?vue&type=template&id=3ff56e1b&scoped=true"
import script from "./TopicCardView.vue?vue&type=script&lang=js"
export * from "./TopicCardView.vue?vue&type=script&lang=js"

import "./TopicCardView.vue?vue&type=style&index=0&id=3ff56e1b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff56e1b"]])

export default __exports__